import React from 'react';
import { ApolloProvider as DefaultApolloProvider } from 'react-apollo';
import { ApolloProvider as DefaultApolloHooksProvider } from '@apollo/client';
export var ApolloProvider = function (_a) {
    var children = _a.children, client = _a.client;
    return (React.createElement(DefaultApolloProvider, { client: client },
        React.createElement(DefaultApolloHooksProvider, { client: client }, children)));
};
//# sourceMappingURL=default.js.map